import { AnyPeriod, AnyPrice, TranslatedString } from "@ct-react/core";
import { FormattedBookingOption } from "@ct-react/calendar";
import { ArticleDataUrl } from "@shared/models/urls";
import { Image } from "./medias";

export type ResumeFeaturesData = {
  rooms?: number;
  maxGuests?: number;
  bedrooms?: number;
};

export type Discount = {
  logic: string;
  period: AnyPeriod;
  type: string;
  fixedValue: AnyPrice;
  percentageValue: number;
};

type SeasonalPrice = {
  period: AnyPeriod;
  isMonthly: boolean;
  onDemand: boolean;
  value: AnyPrice;
};

type RentalLowestPrice = {
  type: "DAILY" | "WEEKLY";
  onDemand: boolean;
  value: AnyPrice;
}

type PriceResumeType = FormattedBookingOption | SeasonalPrice | RentalLowestPrice;

export type ResumeBookChoice = {
  title: string;
  address: string;
  thumbnail?: Image;
  price?: PriceResumeType
}

type ArticleSummary = ArticleDataUrl & {
  __typename: string;
  title: TranslatedString,
  images: Image[];
  features: ResumeFeaturesData;
}

export type RentalArticleSummary = ArticleSummary & {
  discounts?: Discount[];
  bookingSuggestion?: FormattedBookingOption;
}

export type SeasonalArticleSummary = ArticleSummary & {
  price?: SeasonalPrice;
}

export type AnyArticleSummary = RentalArticleSummary | SeasonalArticleSummary;

export const isRentalArticleSummary = (value: AnyArticleSummary): value is RentalArticleSummary =>
  value.__typename === "RentalAccommodationArticle";

export const isSeasonalArticleSummary = (value: AnyArticleSummary): value is SeasonalArticleSummary =>
  value.__typename === "SeasonalAccommodationArticle";

export const isBookingSuggestionPrice = (value?: PriceResumeType): value is FormattedBookingOption =>
  !!value && "period" in value && "price" in value;

export const isRentalLowestPrice = (value?: PriceResumeType): value is RentalLowestPrice =>
  !!value && "type" in value && "onDemand" in value && !value.onDemand;

export const isSeasonalPrice = (value?: PriceResumeType): value is SeasonalPrice =>
  !!value && "isMonthly" in value &&  "onDemand" in value && !value.onDemand;
